const stateManager = require('./stateManager');

module.exports.dispatch = function (action)
{
    const store = stateManager.getStore();
    store.dispatch(action);
}